import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";
import { Save, Trash2, Plus } from "lucide-react";

const FIELDS = [
  { k: "name", l: "Nombre empresa" }, { k: "claim", l: "Claim / lema" },
  { k: "cif", l: "CIF FABRIPAN" }, { k: "legal_name", l: "Razón social (facturas y aviso legal)" },
  { k: "legal_address", l: "Domicilio social" }, { k: "registry", l: "Datos registrales (Registro Mercantil, tomo, folio, hoja)" },
  { k: "address", l: "Dirección" },
  { k: "default_weight_kg", l: "Peso por defecto de productos sin peso (kg)" },
  { k: "shipping_fuel_pct", l: "Recargo carburante transporte (%)" },
  { k: "free_shipping_threshold", l: "Envío gratis a partir de (€ base imponible, 0 = nunca)" },
  { k: "city", l: "Población / CP" }, { k: "province", l: "Provincia" },
  { k: "country", l: "País" }, { k: "phone", l: "Teléfono" },
  { k: "email", l: "Email" }, { k: "support_hours", l: "Horario de soporte" },
  { k: "order_emails", l: "Emails que reciben los pedidos (separados por comas)" },
  { k: "transport_text", l: "Texto de transporte" }, { k: "return_text", l: "Texto de devoluciones" },
  { k: "bank_iban", l: "IBAN bancario" }, { k: "bank_holder", l: "Titular cuenta" },
];

export default function AdminConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { adminApi.get("/config").then((r) => setCfg(r.data)); }, []);

  const save = async () => {
    await adminApi.put("/admin/config", cfg);
    toast.success("Configuración guardada");
  };

  if (!cfg) return <div className="h-40 bg-secondary animate-pulse rounded-sm" />;

  return (
    <div className="max-w-2xl">
      <h1 className="font-heading font-bold text-3xl tracking-tighter mb-6">Configuración · Datos de empresa</h1>
      <div className="bg-white border border-border rounded-sm p-5 space-y-4">
        {FIELDS.map((f) => (
          <div key={f.k}>
            <label className="text-sm font-medium block mb-1">{f.l}</label>
            <input value={cfg[f.k] || ""} onChange={(e) => setCfg({ ...cfg, [f.k]: e.target.value })} className="w-full px-3 py-2 text-sm border border-border rounded-sm" data-testid={`config-${f.k}`} />
          </div>
        ))}
        <div>
          <label className="text-sm font-medium block mb-1">Tipo de IVA</label>
          <input type="number" step="0.01" value={cfg.iva_rate ?? 0.21} onChange={(e) => setCfg({ ...cfg, iva_rate: parseFloat(e.target.value) })} className="w-full px-3 py-2 text-sm border border-border rounded-sm" data-testid="config-iva" />
        </div>
        <div>
          <label className="text-sm font-medium block mb-2">Menú del encabezado</label>
          {(cfg.header_menu || []).map((m, i) => (
            <div key={i} className="border border-border rounded-sm p-2 mb-2">
              <div className="flex gap-2">
                <input value={m.label || ""} onChange={(e) => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, label: e.target.value } : x) })} placeholder="Texto" className="flex-1 px-3 py-2 text-sm border border-border rounded-sm" data-testid={`menu-label-${i}`} />
                <input value={m.link || ""} onChange={(e) => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, link: e.target.value } : x) })} placeholder="/ruta" className="flex-1 px-3 py-2 text-sm border border-border rounded-sm font-mono" data-testid={`menu-link-${i}`} />
                <button onClick={() => setCfg({ ...cfg, header_menu: cfg.header_menu.filter((_, ix) => ix !== i) })} className="text-destructive px-2"><Trash2 className="h-4 w-4" /></button>
              </div>
              <div className="pl-4 mt-2 space-y-1">
                {(m.children || []).map((s, si) => (
                  <div key={si} className="flex gap-2">
                    <input value={s.label || ""} onChange={(e) => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, children: x.children.map((y, iy) => iy === si ? { ...y, label: e.target.value } : y) } : x) })} placeholder="Subtexto" className="flex-1 px-2 py-1.5 text-xs border border-border rounded-sm" data-testid={`submenu-label-${i}-${si}`} />
                    <input value={s.link || ""} onChange={(e) => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, children: x.children.map((y, iy) => iy === si ? { ...y, link: e.target.value } : y) } : x) })} placeholder="/ruta" className="flex-1 px-2 py-1.5 text-xs border border-border rounded-sm font-mono" />
                    <button onClick={() => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, children: x.children.filter((_, iy) => iy !== si) } : x) })} className="text-destructive px-1"><Trash2 className="h-3.5 w-3.5" /></button>
                  </div>
                ))}
                <button onClick={() => setCfg({ ...cfg, header_menu: cfg.header_menu.map((x, ix) => ix === i ? { ...x, children: [...(x.children || []), { label: "", link: "/" }] } : x) })} className="text-[11px] text-brand hover:underline" data-testid={`submenu-add-${i}`}>+ subenlace</button>
              </div>
            </div>
          ))}
          <button onClick={() => setCfg({ ...cfg, header_menu: [...(cfg.header_menu || []), { label: "", link: "/" }] })} className="text-xs inline-flex items-center gap-1 border border-border rounded-sm px-2 py-1 hover:border-brand" data-testid="menu-add"><Plus className="h-3 w-3" /> Añadir enlace</button>
          <p className="text-xs text-muted-foreground mt-1">Vacío = menú por defecto (Tienda, Nosotros, Contacto).</p>
        </div>
        <button onClick={save} className="inline-flex items-center gap-2 bg-brand text-white px-6 py-3 rounded-sm font-semibold hover:bg-brand-dark" data-testid="save-config-btn"><Save className="h-4 w-4" /> Guardar configuración</button>
      </div>
    </div>
  );
}
